module.exports = __webpack_public_path__ + "img/route_nodata_down.d22229b9.png";